import { useMutation, useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { chromaVectorSyncQueryRootKey } from "../config";
import {
  executeChromaVectorSyncTarget,
  fetchChromaVectorSyncTargets,
} from "../repo/chromaVectorSyncRepo";
import type { ChromaVectorSyncRunResult } from "../types";

/** 格式化同步向量库操作错误提示。 */
function formatActionError(prefix: string, error: unknown): string {
  if (error instanceof Error && error.message.trim().length > 0) {
    return `${prefix}：${error.message}`;
  }
  return prefix;
}

/** 管理同步向量库页面查询与执行操作。 */
export function useChromaVectorSyncRuntime() {
  const [latestResult, setLatestResult] = useState<ChromaVectorSyncRunResult>();
  const [actionErrorMessage, setActionErrorMessage] = useState("");
  const query = useQuery({
    queryKey: chromaVectorSyncQueryRootKey,
    queryFn: fetchChromaVectorSyncTargets,
  });

  const executeMutation = useMutation({
    mutationFn: (targetKey: string) => executeChromaVectorSyncTarget(targetKey),
  });

  return {
    targets: query.data?.items ?? [],
    loading: query.isLoading,
    errorMessage: query.error ? "同步向量库对象加载失败，请稍后重试。" : actionErrorMessage,
    executingTargetKey: executeMutation.isPending ? executeMutation.variables : undefined,
    latestResult,
    async handleExecute(targetKey: string) {
      setActionErrorMessage("");
      try {
        const result = await executeMutation.mutateAsync(targetKey);
        setLatestResult(result);
      } catch (error) {
        setActionErrorMessage(
          formatActionError("执行同步向量库失败，请检查后端代理或 Chroma 服务", error),
        );
      }
    },
  };
}
